<template>
	<div id="app" :class="vueAppClasses">
		<router-view @set-app-classes="setAppClasses" />
	</div>
</template>

<style lang="css">
  body {
      color: #050505 !important;
  }
  .router-view{
        padding: 2.2rem !important;
  }
  body,
  .vs-button{
    font-family: arial,sans-serif !important;
  }
  .navbar-floating .vx-navbar-wrapper{
    height: 64px !important;
    position: absolute !important;
  }
  .vs-navbar.navbar-skelton{
    padding: 0.2rem 2rem;
  }
  @media (min-width: 1200px){
    .main-horizontal.navbar-floating .router-content {
        margin-top: 8rem !important;
    }
  }
  .vs-button--link .vs-button-text{
    text-decoration: underline;
    color: blue;
  }
  .vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td{
    padding: 9px 5px !important
  }
  .vs-button.small{
    font-size: 1em !important;
  }
  .vs-button.small:not(.includeIconOnly){
    padding: 0.4rem 1.0rem;
  }
  .vs-tabs-with-badge{
    bottom: 0px !important;
    color: #cc2424 !important;
  }
  .menu-link .h-nav-menu-item a{
    padding: .5rem 1.1rem !important;
  }
  /* .vs-con-table .vs-con-tbody .vs-table--tbody-table{
    font-size: 14px !important;
  } */
  .vx-navbar-wrapper.nav-menu-wrapper{
    top: 55px !important;
  }
  .btn_p0{
    padding: 0px !important
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
  }
  .vs-table--search-input{
    width: 180px !important;
  }
  .vs-con-table .vs-table--header .vs-table--search i{
    left: 5px !important;
  }
  .vx-card .vx-card__collapsible-content .vx-card__body{
    padding: 0.5rem !important;
  }
  
</style>
<script>
import themeConfig from '@/../themeConfig.js'

export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);

  },
  unmounted() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>
